import React from 'react';
import { connect } from 'react-redux';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { selectNameByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PhotoInputContainer } from './partials/PhotoInputContainer';
import { PhotoInputWindowContext } from './partials/PhotoInputWindowContext';

export const _PhotoInputControl = ({ variableIds, name }: Props) => {
    const isMobile = useMobile();
    if (isMobile) {
        return <PhotoInputWindowContext variableIds={variableIds} name={name} />;
    } else {
        return <PhotoInputContainer variableIds={variableIds} />;
    }
};

type Props = {
    variableIds: string[];
    name: string | undefined;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    name: selectNameByVariableId(state, ownProps.variableIds[0])
});

export const PhotoInputControl = connect(
    mapStateToProps
)(_PhotoInputControl);